import { bytesToBase64 } from '@/helpers/Func'

export const useBuffer = () => {
	function buffer2Base64(arrayBuffer, mimetype = 'image/jpeg') {
		if (typeof arrayBuffer === 'undefined') return undefined
		return (
			'data:' +
			mimetype +
			';base64,' +
			bytesToBase64(new Uint8Array(arrayBuffer))
		)
	}
	return {
		buffer2Base64,
	}
}
